import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = "";

export const UserQuestionData = createSlice({
    name: "UserQuestionData",
    initialState: {
        value: initialStateValue,
    },
    reducers: {
        setUserQuestionDataReducer: (state, action) => {
            state.value = action.payload;
        },
        clearUserQuestionDataReducer: (state) => {
            state.value = initialStateValue;
        },
    },
});

export const { setUserQuestionDataReducer, clearUserQuestionDataReducer } = UserQuestionData.actions;
export default UserQuestionData.reducer;